import React from "react";

const ViewPaymentProofModal = ({ data }) => {
  return (
    <div className="mt-2 mb-3 ">
      <div className="d-flex align-items-center justify-content-center w-100 overflow-hidden">
        <img className="notification-image-modal-img" src={process.env.REACT_APP_URL_S3 + "/" + data} style={{ height: "400px", objectFit: "fill" }} />
      </div>
    </div>
  );
};

export default ViewPaymentProofModal;
